module.exports = __webpack_public_path__ + "media/images/svgs/jobs/government-d49dc7eff9d858d2de0d845d0c2fe95a.svg";